import React, { useContext } from 'react'

import {
  IGetAllItemsResponse,
  IGetAllSubItensResponse
} from 'services/GST/CadastroItensSubitensSeguranca'

import {
  SecurityItemsAndSubItensProvider,
  SecurityItemsAndSubItensContext
} from './provider'

interface SelectItemForEditProps {
  isSubItem?: boolean
  item: IGetAllItemsResponse | IGetAllSubItensResponse
}

interface IUseSecurityItensAndSubItensReturn {
  selectedItemForEdit: IGetAllItemsResponse | IGetAllSubItensResponse
  setSelectedItemForEdit: React.Dispatch<
    React.SetStateAction<IGetAllItemsResponse>
  >
  handleSelectItemForEdit: (_props: SelectItemForEditProps) => void
  showEditItemModal: boolean
  toggleEditItemModal: () => void
  selectedItem: IGetAllItemsResponse
  handleSelectItem: (_item: IGetAllItemsResponse) => void
}

const useSecurityItensAndSubItens = (): IUseSecurityItensAndSubItensReturn => {
  const {
    selectedItemForEdit,
    setSelectedItemForEdit,
    showEditItemModal,
    toggleEditItemModal,
    selectedItem,
    setSelectedItem
  } = useContext(SecurityItemsAndSubItensContext)

  const handleSelectItemForEdit = (props: SelectItemForEditProps) => {
    setSelectedItemForEdit({
      ...props.item,
      ...(props.isSubItem && { isSubItem: true })
    })
    toggleEditItemModal()
  }

  const handleSelectItem = (item: IGetAllItemsResponse) => {
    setSelectedItem(item)
  }

  return {
    handleSelectItem,
    handleSelectItemForEdit,
    selectedItem,
    selectedItemForEdit,
    setSelectedItemForEdit,
    showEditItemModal,
    toggleEditItemModal
  }
}

export { useSecurityItensAndSubItens, SecurityItemsAndSubItensProvider }
